import React, { useState, useEffect } from "react";
import { FaEye } from "react-icons/fa";
import Modal from "react-bootstrap/Modal";
import { apiRequestHandler } from "../../apiConfig/service";
import { formatDate } from "../../utils/formatedDate";
import DataTable from "react-data-table-component";

const getAllContacts = async (endPoint, token) => {
  const res = await apiRequestHandler({
    endPoint,
    headers: { Authorization: `Bearer ${token}` },
  });
  console.log(res)
  return res.data;
};

const ContactManagement = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [contacts, setContacts] = useState([]);
  const [filteredContacts, setFilteredContacts] = useState([]);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    setIsLoading(true);
    getAllContacts("getContactFormData", localStorage.getItem("token"))
      .then((res) => setContacts(res || []))
      .finally(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    const filtered =
      contacts?.filter(
        (c) =>
          c?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          c?.email?.toLowerCase().includes(searchTerm.toLowerCase())
      ) || [];
    setFilteredContacts(filtered);
  }, [searchTerm, contacts]);

  const handleViewClick = (contact) => {
    setSelectedContact(contact);
    setShowViewModal(true);
  };

  const trimText = (text, maxLength = 50) => {
    if (!text) return "N/A";
    return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
  };

  const columns = [
    {
      name: 'Sr No.',
      selector: (row, index) => (currentPage - 1) * 10 + index + 1,
      width: '80px',
    }
    ,
    {
      name: "Name",
      selector: (row) => trimText(row.name),
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => trimText(row.email),
      sortable: true,
    },
    {
      name: "Description",
      selector: (row) => trimText(row.description),
      sortable: false,
      // grow: 2,
      // wrap: true,
    },
    {
      name: "Created At",
      selector: (row) => row.createdAt,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <FaEye
          title="View"
          style={{ color: "#064a8c", cursor: "pointer" }}
          onClick={() => handleViewClick(row)}
        />
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const modalStyle = {
    label: {
      fontWeight: 600,
      fontSize: "14px",
      marginBottom: "8px",
      color: "#333",
    },
    value: {
      fontSize: "14px",
      color: "#555",
      marginBottom: "16px",
      wordBreak: "break-word",
    },
  };

  return (
    <div style={{ minHeight: "100vh", padding: "20px", background: "#f5f7fa" }}>
      <div style={{ backgroundColor: "#fff", padding: "20px", borderRadius: "10px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",

            flexWrap: "wrap",
            marginBottom: "20px",
          }}
        >
          <h4 style={{ margin: 0 }}>Contact Management</h4>
        </div>
      </div>
      <br />
      <div className="modifyTable" style={{ borderRadius: "12px" }}>
        <DataTable
          title=""
          columns={columns}
          data={filteredContacts}
          pagination
          highlightOnHover
          onChangePage={setCurrentPage}
          paginationDefaultPage={currentPage}
          responsive
          striped
          progressPending={isLoading}
          subHeader
          subHeaderComponent={
            <input
              type="text"
              placeholder="Search by name or email..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                padding: "8px 12px",
                borderRadius: "6px",
                border: "1px solid #ddd",
                fontSize: "14px",
                width: "250px",
              }}
            />
          }
        />
      </div>

      {/* Modal for View */}
      <Modal show={showViewModal} onHide={() => setShowViewModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Contact Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedContact && (
            <div>
              <div>
                <div style={modalStyle.label}>Name</div>
                <div style={modalStyle.value}>{selectedContact.name || "N/A"}</div>
              </div>
              <div>
                <div style={modalStyle.label}>Email</div>
                <div style={modalStyle.value}>{selectedContact.email || "N/A"}</div>
              </div>
              <div>
                <div style={modalStyle.label}>Mobile</div>
                <div style={modalStyle.value}>{selectedContact.mobile || "N/A"}</div>
              </div>
              <div>
                <div style={modalStyle.label}>Description</div>
                <div style={modalStyle.value}>{selectedContact.description || "N/A"}</div>
              </div>
              <div>
                <div style={modalStyle.label}>Created At</div>
                <div style={modalStyle.value}>{selectedContact.createdAt}</div>
              </div>
              {/* <div>
                <div style={modalStyle.label}>Updated At</div>
                <div style={modalStyle.value}>{formatDate(selectedContact.updatedAt)}</div>
              </div> */}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            style={{
                           background: "linear-gradient(to bottom right, #163252, #0081ff)",

              color: "#fff",
              border: "none",
              padding: "8px 16px",
              borderRadius: "5px",
              cursor: "pointer",
              fontSize: "14px",
            }}
            onClick={() => setShowViewModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ContactManagement;
